export default __webpack_public_path__ + "static/media/scroll_logo.2ce586a8.svg";